import React, { Component } from "react";
import Picture from "../Shared/Picture";
import Breadcrumbs from "Header/Breadcrumbs";
import isBreadcrumb from "Shared/isBreadcrumb";

class Header extends Component {
    onHeaderClick = () => {
        let isProductPage =
            window.location.href.indexOf("hair-loss-products") > 0;
        // let productHeader = document.getElementsByClassName("main-visual");
        if (isProductPage) {
            let url = this.props.topHeader.SliderButtons[0].ButtonTarget.Value;
            window.location.href = url;
        }
    };

    render() {
        let isProductPage = window.location.href.indexOf("hair-loss-products") > 0;

        const {
            SliderImage,
            SliderImageAlt,
            Title,
            Subtitle,
            SliderButtons,
            VisualHeader,
            VisualParagraph,
        } = this.props.topHeader;

        return VisualHeader.Value !== "" ? (
            <div className="main-visual">
                <div className="visual-img">
                    {SliderImage.Value[0] != null ? (
                        <Picture
                            src={SliderImage.Value}
                            alt={SliderImageAlt.Value}
                            mobileHeight={428}
                            mobileWidth={640}
                            visibleByDefault={true}
                        />
                    ) : null}
                    {this.props.breadcrumbs && (
                        <Breadcrumbs
                            breadcrumbProps={isBreadcrumb(
                                this.props.breadcrumbs
                            )}
                        />
                    )}
                    {Title.Value != "" || Subtitle.Value != "" ? (
                        <div className="visual-text side-left">
                            <section>
                                <h1>
                                    <span className="small-header">
                                        {Title.Value}
                                    </span>
                                    {Subtitle.Value != "" && (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: Subtitle.Value,
                                            }}
                                        ></span>
                                    )}
                                </h1>
                                {SliderButtons.length > 0 ? (
                                    <a
                                        href={
                                            SliderButtons[0].ButtonTarget.Value
                                        }
                                        className="button"
                                    >
                                        {SliderButtons[0].ButtonText.Value}
                                    </a>
                                ) : null}
                            </section>
                        </div>
                    ) : null}
                </div>
                {VisualHeader.Value !== "" ? (
                    <div
                        className={
                            VisualParagraph.Value !== ""
                                ? "visual-header header-and-text"
                                : "visual-header"
                        }
                    >
                        <h2
                            dangerouslySetInnerHTML={{
                                __html: VisualHeader.Value,
                            }}
                        ></h2>
                        {VisualParagraph.Value !== "" ? (
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: VisualParagraph.Value,
                                }}
                            ></p>
                        ) : null}
                    </div>
                ) : null}
            </div>
        ) : (
            <div
                onClick={this.onHeaderClick}
                className={
                    "main-visual " +
                    (isProductPage ? "clickable" : "")
                }
            >
                {SliderImage.Value[0] != null ? (
                    <Picture
                        src={SliderImage.Value}
                        alt={SliderImageAlt.Value}
                        mobileWidth={640}
                        mobileHeight={428}
                        visibleByDefault={true}
                    />
                ) : null}
                {this.props.breadcrumbs && (
                    <Breadcrumbs
                        breadcrumbProps={isBreadcrumb(this.props.breadcrumbs)}
                    />
                )}
                {Title.Value != "" || Subtitle.Value != "" && (
                    <div className="visual-text side-left">
                        <section>
                            <h1>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: Title.Value,
                                    }}
                                />
                                {Subtitle.Value != "" && (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: Subtitle.Value,
                                        }}
                                    ></span>
                                )}
                            </h1>
                            {SliderButtons.length > 0 ? (
                                <a
                                    href={SliderButtons[0].ButtonTarget.Value}
                                    className="button"
                                >
                                    {SliderButtons[0].ButtonText.Value}
                                </a>
                            ) : null}
                        </section>
                    </div>
                )}
            </div>
        );
    }
}
export default Header;
